@if (currentPage().data.length > 0) {
  <div class="invoice-summary-card-container">
    <div class="column-headings">
      <div class="remaining-amount-heading">REMAINING</div>
    </div>
    @if (clickableRows()) {
      @for (invoice of currentPage().data; track invoice) {
        <a class="row" [routerLink]="invoice.detailsRouterLinkCommands" [attr.aria-label]="invoice.detailsLabel">
          <app-invoice-summary-card [invoice]="invoice"></app-invoice-summary-card>
        </a>
      }
    }
    @if (!clickableRows()) {
      @for (invoice of currentPage().data; track invoice) {
        <button type="button" class="row" [attr.aria-label]="invoice.detailsLabel" [attr.title]="invoice.detailsLabel">
          <app-invoice-summary-card [invoice]="invoice"></app-invoice-summary-card>
        </button>
      }
    }
  </div>
}
